<section>
  <h1> {{ data.title || 'Compartilhar'}} </h1>

  <a class="wpp" (click)="eventShared('wpp')"> <i icon="whatsapp"></i> </a>
  <a class="face" (click)="eventShared('face')"> <i icon="facebook"></i> </a>
  <a class="twitter" (click)="eventShared('twitter')"> <i icon="twitter"></i> </a>
  <a class="linkedin" (click)="eventShared('linkedin')"> <i icon="linkedin"></i> </a>
  <a class="shared" (click)="eventShared('shared')"> <i icon="shared"></i> </a>
  <a class="copy" (click)="eventShared('copy')"> <i icon="copy"></i> </a>
</section>
